import {observer} from "mobx-react";
import * as React from "react";

import './BoothHandout.pcss';

interface IBoothHandout_Props {
  handout:any;
}

@observer
export class BoothHandout extends React.Component<IBoothHandout_Props> {
  render() {
    return(
      <a className="boothHandout" href={this.props.handout.bottomLinkAction} target={"_blank"} >
        <i className={this.props.handout.icon} style={{fontFamily:'wellness-concepts'}}></i>
        {this.props.handout.title}
      </a>
    );
  }
}
